module.exports = __webpack_public_path__ + "static/media/waves.e609e916.svg";